import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, X, Star } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getUserSubscription, isSubscriptionActive, getSubscriptionPlanName } from '../lib/stripe';

const SubscriptionBanner: React.FC = () => {
  const [subscription, setSubscription] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const { userProfile } = useAuth();

  useEffect(() => {
    const fetchSubscription = async () => {
      if (!userProfile) return;
      
      try {
        setLoading(true);
        const data = await getUserSubscription();
        setSubscription(data);
      } catch (err) {
        console.error('Error fetching subscription:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [userProfile]);

  // Don't show banner if loading, dismissed, or user has active subscription
  if (loading || dismissed || (subscription && isSubscriptionActive(subscription?.subscription_status))) {
    return null;
  }

  return (
    <div className="bg-indigo-900 rounded-lg p-3 mb-4 relative border border-indigo-700">
      <button 
        onClick={() => setDismissed(true)}
        className="absolute top-2 right-2 text-indigo-300 hover:text-white"
      >
        <X className="w-4 h-4" />
      </button>
      
      <div className="flex items-center space-x-3">
        <div className="bg-indigo-800 p-2 rounded-lg">
          <Star className="w-5 h-5 text-yellow-400" />
        </div>
        <div className="flex-1">
          <p className="text-xs text-indigo-200 mb-1">
            {subscription ? 'Your subscription has expired' : 'You\'re using the free version'}
          </p>
          <p className="text-xs text-indigo-300">
            Upgrade to unlock all features and AI capabilities
          </p>
        </div>
      </div>
      
      <div className="mt-3">
        <Link 
          to="/pricing"
          className="w-full py-2 px-3 bg-indigo-600 hover:bg-indigo-700 text-white text-xs rounded flex items-center justify-center transition-colors"
        >
          <CreditCard className="w-3 h-3 mr-1" />
          <span>View Pricing</span>
        </Link>
      </div>
    </div>
  );
};

export default SubscriptionBanner;